import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

interface Props {
  label: string
  value: string
  onChange: (value: string) => void
  options: { label: string; value: string }[]
  allLabel: string
}

/** A filter dropdown whose first option clears the filter (`''`). */
export const FilterSelect = ({ label, value, onChange, options, allLabel }: Props) => (
  <Select value={value || 'all'} onValueChange={(v) => onChange(v === 'all' ? '' : v)}>
    <SelectTrigger aria-label={label} className="w-full sm:w-56">
      <SelectValue placeholder={label} />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{allLabel}</SelectItem>
      {options.map((o) => (
        <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
)
